// Synthesized bell chime using the Web Audio API (no asset file needed).
let ctx;
let ringTimer = null;

function chime(volume, repeats) {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    const now = ctx.currentTime;
    for (let r = 0; r < repeats; r++) {
      const offset = r * 0.55;
      [880, 1320, 1760].forEach((freq, i) => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.type = "sine";
        osc.frequency.value = freq;
        const start = now + offset + i * 0.08;
        gain.gain.setValueAtTime(0.0001, start);
        gain.gain.exponentialRampToValueAtTime(volume, start + 0.02);
        gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.9);
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.start(start);
        osc.stop(start + 1);
      });
    }
  } catch (e) {
    // audio not available
  }
}

// Single bell chime
export function playBell() {
  chime(0.35, 1);
}

// Louder double-chime, repeated every 1.5s until stopped
export function startBellLoop() {
  stopBellLoop();
  chime(0.6, 2);
  ringTimer = setInterval(() => chime(0.6, 2), 1500);
}

export function stopBellLoop() {
  if (ringTimer) {
    clearInterval(ringTimer);
    ringTimer = null;
  }
}
